import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { pluralise, stringFromArray } from '../../../../../../../utils/stringUtils';

import ReadOnlyBlock from '../../../../../../../components/ReadOnlyBlock';
import { EnumSenderType, SenderUser } from '../../../Common';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>,
  user: SenderUser,
  assignedOrganisations: string[],
  userTypes: EnumSenderType[],
  setStep: React.Dispatch<React.SetStateAction<number>>,
}

const StepReview = ({ classes, user, userTypes, assignedOrganisations, setStep }: Props): React.ReactElement => {
  return (
    <>
      <ReadOnlyBlock
        items={[
          { label: 'Name', value: stringFromArray([user.first_name, user.last_name]) },
          { label: 'Email', value: user.email },
        ]}
        handleEdit={() => setStep(0)} />
      <ReadOnlyBlock
        items={[
          { label: 'User role', value: userTypes.find(i => i.sender_type === user.sender_type)?.description }
        ]}
        handleEdit={() => setStep(1)} />
      <ReadOnlyBlock
        items={[
          { label: `${assignedOrganisations.length} ${pluralise('Assigned organisation', assignedOrganisations.length)}`, list: assignedOrganisations },
        ]}
        handleEdit={() => setStep(2)} />
    </>
  );
};

export default withStyles(styles)(StepReview);
